// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>15</span>&nbsp;&nbsp;My mouth shall tell of your righteousness<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;and salvation all the day long,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;for I know no end of the telling.<br> </p> </div></div>";
// Exports
module.exports = code;